import StatCard from '../../StatCard/StatCard';
import { useCampaign } from '../useCampaign';

export const CampaignStats = () => {
  const { campaignsStats } = useCampaign();
  const cards = [
    {
      title: 'Campagne total',
      value: campaignsStats?.totalCampaigns,
      valueColor: 'text-[#FEC200]',
    },
    {
      title: 'Campagne en cours',
      value: campaignsStats?.totalOngoing,
      valueColor: 'text-[#FEC200]',
    },
    {
      title: 'Campagne en attentes',
      value: campaignsStats?.totalPending,
      valueColor: 'text-[#FEC200]',
    },
    {
      title: 'Campagne terminées',
      value: campaignsStats?.totalCompleted,
      valueColor: 'text-[#FEC200]',
    },
  ];
  return (
    <div className="py-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(({ title, value, valueColor }, index) => (
          <StatCard
            key={index}
            title={title}
            value={value || 0}
            valueColor={valueColor}
          />
        ))}
      </div>
    </div>
  );
};
